import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgIndicatorHtml = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M8.2 5 1 12l7.2 7m7.6-14 7.2 7-7.2 7"
	})
});
export default SvgKgIndicatorHtml;
